export default "__VITE_ASSET__BMcEOTuY__"